import TextField from '@mui/material/TextField';
import useOnboardingSx from '../../hooks/useOnboardingSx';

export default function Field(props) {
  const sx = useOnboardingSx();
  return <TextField size="small" fullWidth sx={sx.field} {...props} />;
}
